import { Button, Image, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";
import { H2, BodyText } from "src/atoms/typography";
import getImageSrc from "src/utils/getImageSrc";
import { getAppValue } from "src/utils/environment";

export default function LoadingMonitoringsErrorView({ onRetry, onClose }) {
  const { t } = useTranslation();
  const imageSource = getAppValue({
    barkio: "sad-dog.svg",
    bibino: "empty.svg"
  });
  return (
    <WithNavigationBarLayout
      navigationBarProps={{
        headingKey: "activityLog.heading",
        onClose
      }}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        width="320px"
        justifyContent="space-between"
        mx="auto"
        pt="28px"
        height="100%"
      >
        <Flex flexDirection="column" alignItems="center">
          <Image src={getImageSrc(imageSource)} width="176px" />
          <H2 color="highEmphasis" textAlign="center" mt="24px">
            {t("activityLog.loadingError.heading")}
          </H2>
          <BodyText color="mediumEmphasis" textAlign="center" mt="8px">
            {t("activityLog.loadingError.text")}
          </BodyText>
        </Flex>
        <Button
          variant="flatPrimary"
          onClick={onRetry}
          minWidth="196px"
          mb="8px"
        >
          {t("buttons.retry")}
        </Button>
      </Flex>
    </WithNavigationBarLayout>
  );
}
